import cx from "classnames"
import * as React from "react"
import * as styles from "./styles.module.scss"
import Tags, { TagsType } from "../../Post/Tags"
import Tag from "../../Post/Tag"

interface IProps {
  className?: string
}

const CategoryTags = ({ className }: IProps) => {
  return (
    <nav className={styles.categoryTags}>
      <div className={styles.pagePadding}>
        <div className={styles.tags}>
          <Tags type={TagsType.CATEGORY}>
            <li className={styles.tag}>
              <a id="LinkTo-all" href="/content/" title="All">
                <Tag>All</Tag>
              </a>
            </li>
            <li className={styles.tag}>
              <a
                id="LinkTo-homeBuying"
                href="/content/tag/home-buying/"
                title="Home buying"
              >
                <Tag>Home buying</Tag>
              </a>
            </li>
            <li className={styles.tag}>
              <a
                id="LinkTo-refinancing"
                href="/content/tag/refinancing/"
                title="Refinancing"
              >
                <Tag>Refinancing</Tag>
              </a>
            </li>
            <li className={styles.tag}>
              <a id="LinkTo-tools" href="/content/tag/tools/" title="Tools">
                <Tag>Tools</Tag>
              </a>
            </li>
            <li className={styles.tag}>
              <a
                id="LinkTo-affordableLending"
                href="/content/tag/affordable-lending/"
                title="Affordable lending"
              >
                <Tag>Affordable lending</Tag>
              </a>
            </li>
            <li className={styles.tag}>
              <a
                id="LinkTo-firstTimeHomebuyers"
                href="/content/tag/first-time-homebuyers/"
                title="First-time homebuyers"
              >
                <Tag>First-time homebuyers</Tag>
              </a>
            </li>
          </Tags>
        </div>
      </div>
    </nav>
  )
}

export default CategoryTags
